module.exports = __webpack_public_path__ + "static/phone-carrier-rescue-logo-9eee36fa3ad78c020896eaa184f9beed.jpg";